import authUtils from '../../services/auth/authUtils';
import LegacyPasswordForm from './components/LegacyPasswordForm';
import CognitoPasswordForm from './components/CognitoPasswordForm';

const PasswordLayout = () =>
  authUtils.isLegacyAuth() ? <LegacyPasswordForm /> : <CognitoPasswordForm />;
export default PasswordLayout;
